// import { pc_mode_img } from 'logo.svg'
import React from "react";
const pc = () => {
  console.log("window.innerHeight", window.innerHeight);
  console.log("window.innerWidth", window.innerWidth);
  return (
    <div
      style={{
        backgroundColor: "var(--colorPrimary)",
        height: window.innerHeight,
        overflow: "hidden",
      }}
    >
      <img
        src={"assets/img/KV-des.png"}
        style={{
          width: window.innerWidth,
          height: window.innerHeight,
          objectFit: "contain",
        }}
      />
    </div>
  );
};
export default pc;
